export const yodaQuotes = [
  'A wrong turn, you have made.',
  'The path, clear it is not.',
  'Lost in the codebase, are you?',
  '404, hmm? Clouded your navigation is.',
  'This route… strong with the 404, it is.',
  'Find this page, you will not.',
  'Refactor your direction, you must.',
  'The link you followed—misleading, it was.',
  'Misdirected, your click has been.',
  'Return you must. Home, your journey begins again.',
  'Traveled too far into production, have you?',
  'In staging, this page still lives, perhaps.',
  'The Force in this URL, I sense not.',
  'Back to Home, the path of wisdom is.',
  'Broken, your route is. Fix it, a developer must.',
  'Patience, young dev. A new route you will find.',
  'To the homepage, your destiny leads.',
  'Through debugging, clarity you shall gain.',
  'Much confusion, in this 404 I feel.',
  "This is not the component you're looking for.",
  'Lost you are. Found you may yet be.',
  'Mistyped the URL, you perhaps did.',
  'Navigate carefully, one must, in the browser.',
  'Many routes there are, but not this one.',
  'Guidance, you seek. Back to Compass, go you must.',
  'Attend Compass, you must. Great knowledge, you will gain.',
  'Buy a ticket, young Padawan. The learning, endless it is.',
  'Strong with the Code, this conference is.',
  'Tickets, running out they are. Act, you must.',
  'Join the Compass side, you will.',
  'A journey through the galaxy of code, your ticket begins.',
  'Learn you shall. Network you must. Compass awaits.',
  'Miss Compass, you must not. FOMO, strong it is.',
  'Much to teach, the speakers have. Register, you must.',
  'A seat in the hangar, reserve you should.',
  'In the wisdom of the crowd, powerful the Force becomes.',
  'Many routes there are, but only one leads to Compass Detroit.',
  'An adventure in code and community, your destiny it is.',
  'One does not simply skip Compass.',
  'Train with the masters, you will. Buy, your ticket you must.',
  'The Force of innovation, at Compass it gathers.',
  'Ready, your browser must be. Purchase, click you should.',
  'Fear leads to missing out. FOMO leads to regret.',
  'Fulfilled, your curiosity shall be. When ticket, you claim.',
  'A conference for developers, this is. Join, or forever wonder you will.',
]
